module.exports = __webpack_public_path__ + "img/Brian_King@2x.50c1003b.png";